import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Cpu, Cloud, CheckCircle, Bot } from 'lucide-react';
import jtLogo from '../../images/logo/jt.png';
import './ModernHero.scss';

const ModernHero = () => {
    const features = [
        'Compliance for Government Contracts',
        '24/7 Expert Support',
        'Certified Partners'
    ];

    return (
        <section className="jk-hero">
            {/* Background Elements */}
            <div className="jk-hero__bg">
                <div className="jk-hero__bg-gradient"></div>
                <div className="jk-hero__bg-pattern"></div>
                <div className="jk-hero__bg-glow jk-hero__bg-glow--1"></div>
                <div className="jk-hero__bg-glow jk-hero__bg-glow--2"></div>
            </div>

            <div className="jk-hero__container">
                <div className="jk-hero__content">
                    {/* Badge */}
                    <div className="jk-hero__badge">
                        <Shield size={16} />
                        <span>Authorized Technology Partner</span>
                    </div>

                    {/* Main Heading */}
                    <h1 className="jk-hero__title">
                        Enabling Smart<span className="jk-hero__title-highlight"> Technology </span> 
                        for Sustainable <span className="jk-hero__title-accent">Growth</span>
                    </h1>

                    {/* Subtitle */}
                    <p className="jk-hero__subtitle">
                        Empowering government, healthcare, and enterprise with reliable IT solutions and expert support.
                    </p>

                    {/* Features List */}
                    <ul className="jk-hero__features">
                        {features.map((feature, index) => (
                            <li key={index} className="jk-hero__feature">
                                <CheckCircle size={20} className="jk-hero__feature-icon" />
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>

                    {/* CTA Buttons */}
                    <div className="jk-hero__actions">
                        <Link to="/contact" className="jk-btn jk-btn--primary jk-btn--lg">
                            Get Started
                            <ArrowRight size={20} />
                        </Link>
                        <Link to="/about" className="jk-btn jk-btn--outline-light jk-btn--lg">
                            Learn More
                        </Link>
                    </div>

                    {/* Stats */}
                    <div className="jk-hero__stats">
                        <div className="jk-hero__stat">
                            <span className="jk-hero__stat-number">500+</span>
                            <span className="jk-hero__stat-label">Clients Served</span>
                        </div>
                        <div className="jk-hero__stat-divider"></div>
                        <div className="jk-hero__stat">
                            <span className="jk-hero__stat-number">15+</span>
                            <span className="jk-hero__stat-label">Years Experience</span>
                        </div>
                        <div className="jk-hero__stat-divider"></div>
                        <div className="jk-hero__stat">
                            <span className="jk-hero__stat-number">99%</span>
                            <span className="jk-hero__stat-label">Client Satisfaction</span>
                        </div>
                    </div>
                </div>

                {/* Hero Visual */}
                <div className="jk-hero__visual">
                    <div className="jk-hero__visual-container">
                        {/* Floating Cards */}
                        <div className="jk-hero__card jk-hero__card--1">
                            <div className="jk-hero__card-icon jk-hero__card-icon--cyan">
                                <Cpu size={24} />
                            </div>
                            <div className="jk-hero__card-content">
                                <span className="jk-hero__card-title">IT Hardware</span>
                                <span className="jk-hero__card-text">Premium Equipment</span>
                            </div>
                        </div>

                        <div className="jk-hero__card jk-hero__card--2">
                            <div className="jk-hero__card-icon jk-hero__card-icon--blue">
                                <Cloud size={24} />
                            </div>
                            <div className="jk-hero__card-content">
                                <span className="jk-hero__card-title">Cloud Solutions</span>
                                <span className="jk-hero__card-text">Scalable Infrastructure</span>
                            </div>
                        </div>

                        <Link to="/ai-automation" className="jk-hero__card jk-hero__card--3">
                            <div className="jk-hero__card-icon">
                                <Bot size={24} />
                            </div>
                            <div className="jk-hero__card-content">
                                <span className="jk-hero__card-title">AI Automation & Workflows</span>
                                <span className="jk-hero__card-text">Less Time on Repetitive Tasks</span>
                            </div>
                        </Link>

                        {/* Central Graphic */}
                        <div className="jk-hero__graphic">
                            <div className="jk-hero__graphic-ring jk-hero__graphic-ring--outer"></div>
                            <div className="jk-hero__graphic-ring jk-hero__graphic-ring--middle"></div>
                            <div className="jk-hero__graphic-ring jk-hero__graphic-ring--inner"></div>
                            <div className="jk-hero__graphic-center">
                                <img src={jtLogo} alt="Jaak Tech" className="jk-hero__logo" />
                            </div>
                        </div>

                        {/* Connection Lines — radiate from the center logo to each card */}
                        <svg className="jk-hero__connections" viewBox="0 0 500 500">
                            <path className="jk-hero__connection-line" d="M224,196 Q200,150 186,122" />
                            <path className="jk-hero__connection-line" d="M276,196 Q300,150 314,122" />
                            <path className="jk-hero__connection-line" d="M250,310 L250,392" />
                        </svg>
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className="jk-hero__scroll">
                <div className="jk-hero__scroll-mouse">
                    <div className="jk-hero__scroll-wheel"></div>
                </div>
                <span>Scroll to explore</span>
            </div>
        </section>
    );
};

export default ModernHero;
